import React, { useCallback, useState } from 'react';
import { albums } from '../data';
import AlbumsGallery from '../AlbumsGallery';
import * as S from './styles';

const AlbumsDesktop: React.FC = () => {
  const [albumId, setAlbumId] = useState<number | undefined>(undefined);
  const renderAlbums = useCallback(() => {
    return albums.map((album) => (
      <S.AlbumCoverButton key={album.id} onClick={() => setAlbumId(album.id)}>
        <img src={album.cover} alt={album.title} />
      </S.AlbumCoverButton>
    ));
  }, []);
  return (
    <S.Container>
      <AlbumsGallery AlbumId={albumId} onClose={() => setAlbumId(undefined)} />
      {renderAlbums()}
    </S.Container>
  );
};

export default AlbumsDesktop;
